<template>
  <b-container
    fluid
  >
    <b-row class="mb-4">
      <b-col
        cols="12"
      >
        <b-card
          title="SAP Posting"
          sub-title="My Postings"
          class="shadow-sm"
        >
          <b-row>

            <b-col
              cols="12"
              md="2"
              class="p-2"
            >
              <PaleCard
                label="Pending"
                variant="warning"
                :count="postings.pending"
                :link="{ name: 'apa.payments.postings', params: { apa: 'pending' }}"
                :loading="fetching"
              />
            </b-col>
            <b-col
              cols="12"
              md="2"
              class="p-2"
            >
              <PaleCard
                label="Posted"
                variant="success"
                :count="postings.posted"
                :link="{ name: 'apa.payments.postings', params: { apa: 'histories', status: 'posted' }}"
                :loading="fetching"
              />
            </b-col>

          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { core } from '@/config/pluginInit'

import PaleCard from '@/components/custom/PaleCard'

import { SAPADashboard } from '@/services'

export default {
  name: 'ApaDashboard',

  middleware: ['auth', 'apa'],

  components: {
    PaleCard
  },

  metaInfo: () => ({
    title: 'Dashboard'
  }),

  data () {
    return {
      fetching: false,
      postings: {
        pending: 0,
        posted: 0
      }
    }
  },

  mounted () {
    core.index()
    this.getStatistics()
  },

  methods: {

    async getStatistics () {
      this.fetching = true
      return await SAPADashboard.get().then(({ data }) => {
        this.postings.pending = data.pending_sap_posting
        this.postings.posted = data.processed_sap_posting
        this.fetching = false
      })
    }

  }
}
</script>
